export default "__VITE_ASSET__7LInGyWR__"